import * as Yup from 'yup';

const productSchema = Yup.object({
  track_depth: Yup.number()
    .typeError('Urasyvyyden on oltava numero.')
    .required()
    .label('Urasyvyys'),
  price: Yup.number()
    .typeError('Hinnan on oltava numero.')
    .required()
    .label('Perushinta'),
  name: Yup.string()
    .required()
    .label('Nimi'),
  code: Yup.string()
    .required()
    .label('Tuotekoodi'),
  manufacturer_id: Yup.number()
    .required()
    .label('Valmistaja')
});

export default productSchema;
export type ProductSchema = ReturnType<typeof productSchema.cast>;
